import { render, staticRenderFns } from "./WidgetPopover.vue?vue&type=template&id=843890f6&scoped=true&"
import script from "./WidgetPopover.vue?vue&type=script&lang=ts&"
export * from "./WidgetPopover.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetPopover.vue?vue&type=style&index=0&id=843890f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843890f6",
  null
  
)

export default component.exports